(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/authorization/views/authorization.js') >= 0) return;  svs.modules.push('/modules/authorization/views/authorization.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.authorization=_svs.authorization||{};
_svs.authorization.templates=_svs.authorization.templates||{};
svs.authorization.templates.authorization = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"authorization-view\" class=\"js-authorization-view bg-authorization-transparent\">\n  <div class=\"js-authorization-view-loader\"></div>\n</div>";
},"useData":true});
Handlebars.partials['svs-authorization-authorization'] = svs.authorization.templates.authorization;
})(svs, Handlebars);


 })(window);